import { ColDef } from 'ag-grid-enterprise';
export type GenDefs = ColDef<Record<string, string | number>>;
export const xlsxRowsToAgCols = (
  rows: Record<string, string | number>[],
): GenDefs[] => {
  if (rows && rows.length > 0) {
    return Object.keys(rows[0]).map((key) => {
      return {
        field: key,
        headerName: key,
        sortable: true,
        filter: true,
      };
    });
  }
  return [];
};
